/**
 * This module defines the Delete action and its bindings to an `ItemsScope`.
 */
import * as React from 'react';
import { deleteItems as defaultDeleteItems, deleteItemsOperation } from '../../../../operations/deleteItems';
import { makeObject } from '../../../../utilities/objects';
import { withSelectedItems, IDecorateWithSelectedItemsProps } from '../../../decorators/selectors';
import { deleteActionControler, IDeleteWizardProps } from '../../../../controls/deleteActionControl';
import { WithItemCache, IItemCacheStateProps } from '../../../withItemCache/WithItemCache';
import { WizardAction, IWizardActionStateProps } from '../../../wizardAction/WizardAction';

export interface IItemDeleteActionProps {
    itemKeys: string[];
    deleteWizard: React.ComponentType<IDeleteWizardProps>;
    deleteItems?: typeof defaultDeleteItems;
}

export class ItemDeleteAction extends React.PureComponent<IItemDeleteActionProps> {
    public render(): JSX.Element {
        const {
            itemKeys,
            deleteWizard,
            deleteItems = defaultDeleteItems
        } = this.props;

        return (
            <WithItemCache>
                { ({ itemCache, dispatch }: IItemCacheStateProps) => {

                    if (itemKeys.length === 0) {
                        return <WizardAction isAvailable={ false } />;
                    }
                    const isBatchDelete = itemKeys.length > 0;

                    let isAvailable = true;

                    let FinalDeleteWizard = deleteWizard;

                    for (const itemKey of itemKeys) {
                        const controlHandler = itemCache.demandItemFacet(deleteActionControler, itemKey);

                        const {
                            isAvailable: itemIsAvailable,
                            deleteWizard: ItemDeleteWizard
                        } = deleteActionControler.evaluate(controlHandler)(itemCache, {
                            itemKey: itemKey,
                            isAvailable: false,
                            deleteWizard: deleteWizard,
                            isBatchDelete: isBatchDelete
                        });

                        if (!itemIsAvailable) {
                            isAvailable = false;
                        }

                        FinalDeleteWizard = ItemDeleteWizard;
                    }

                    const onDelete = async () => {
                        const options: (typeof deleteItemsOperation.type) = {};
                        await dispatch(deleteItems({
                            items: makeObject(itemKeys, () => options)
                        }));
                    };

                    return (
                        <WizardAction
                            isAvailable={ isAvailable }
                            engagement={ {
                                name: 'Delete',
                                isIntentional: true
                            } }
                        >
                            { (wizardProps: IWizardActionStateProps) => {
                                return (
                                    <FinalDeleteWizard
                                        { ...wizardProps }
                                        onDelete={ onDelete }
                                        itemKeys={ itemKeys }
                                    />
                                );
                            } }
                        </WizardAction>
                    );
                } }
            </WithItemCache>
        );
    }
}

export type IDeleteActionProps = IDecorateWithSelectedItemsProps<IItemDeleteActionProps>;

export const DeleteAction: React.ComponentType<IDeleteActionProps> = withSelectedItems()(ItemDeleteAction);
